<template>
    <div>
        <v-tabs
                slot="extension"
                v-model="model"
                centered
                color="secondary"
                slider-color="primary"
                class="elevation-10"
        >
            <v-spacer v-if="order && order.status_id == 5"></v-spacer>
            <v-spacer></v-spacer>
            <v-tab
                    href="#tab-order"
            >
                Detail
            </v-tab>
            <v-tab
                    href="#tab-info"
            >
                Order confirmation info
            </v-tab>
            <v-tab
                    href="#tab-trs"
            >
                TRS
            </v-tab>
            <v-tab
                    href="#tab-documents"
            >
                Loading documents
            </v-tab>
            <v-tab
                    href="#tab-confirmation"
            >
                Order confirmation
            </v-tab>
            <v-spacer></v-spacer>
            <v-btn v-if="order && order.status_id == 5" color="primary" @click="send">Send notification to client</v-btn>
        </v-tabs>

        <v-tabs-items
                v-model="model"
                class="elevation-10"
        >
            <v-tab-item
                    value="tab-order"
                    lazy
                    :transition="false"
                    :reverse-transition="false"
            >
                <v-card flat>
                    <OrderComponent
                            v-if="order && model == 'tab-order'"
                            :order="order"
                            v-on:updated="getOrderDetail()"
                    ></OrderComponent>
                </v-card>
            </v-tab-item>
            <v-tab-item
                    value="tab-info"
                    lazy
                    :transition="false"
                    :reverse-transition="false"
            >
                <v-card flat>
                    <InfoComponent
                            v-if="model == 'tab-info' && order"
                            :order="order"
                            v-on:update="getOrderDetail()"
                    ></InfoComponent>
                </v-card>
            </v-tab-item>

            <!-- TAB TRS -->
            <v-tab-item
                    value="tab-trs"
                    lazy
                    :transition="false"
                    :reverse-transition="false"
            >
                <v-card flat>
                    <TrsComponent
                            v-if="model == 'tab-trs' && order"
                            :order="order"
                            v-on:update="getOrderDetail()"
                    ></TrsComponent>
                </v-card>
            </v-tab-item>

            <v-tab-item
                    value="tab-documents"
                    lazy
                    :transition="false"
                    :reverse-transition="false"
            >
                <v-card flat>
                    <DocumentsComponent
                            v-if="order && model == 'tab-documents'"
                            :order_id="order.id"
                    ></DocumentsComponent>
                </v-card>
            </v-tab-item>
            <v-tab-item
                    value="tab-confirmation"
                    lazy
                    :transition="false"
                    :reverse-transition="false"
            >
                <v-card flat>
                    <ConfirmationComponent
                            v-if="order && model == 'tab-confirmation'"
                            :order_id="order.id"
                            :confirmed="order.status.id == 2 ? true: false"
                            v-on:signed="getOrderDetail()"
                            v-on:unconfirmed="getOrderDetail()"
                    ></ConfirmationComponent>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>

    import OrderComponent from './views/OrderComponent';
    import DocumentsComponent from './views/DocumentsComponent';
    import InfoComponent from './views/InfoComponent';
    import ConfirmationComponent from './views/ConfirmationComponent';
    import TrsComponent from './views/TrsComponent';

    export default {
        props: ['id'],
        data () {
            return {
                model: 'tab-order',
                order: null
            }
        },
        created () {
            this.setSectionTitle();
            this.getOrderDetail();
            if (this.$route.query.model == 'tab-info') {
                this.model = 'tab-info';
            }
            if (this.$route.query.model == 'tab-documents') {
                this.model = 'tab-documents';
            }
        },
        methods: {
            send() {
                this.$store.dispatch('sendOrderToClient', {
                    id: this.id
                }).then((res) => {
                    this.getOrderDetail();
                });
            },
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Order confirmation detail.'
                });
            },
            getOrderDetail () {
                this.$store.dispatch('getOrderDetail', {
                    id: this.id
                }).then((res) => {

                    this.order = res.data;

                }).catch((error) => {

                });
            }
        },
        components: {
            OrderComponent,
            InfoComponent,
            DocumentsComponent,
            ConfirmationComponent,
            TrsComponent
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/orders/DetailComponent.vue